







































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { StudyDummyBaseMethod } from '@/mixins/requests/student/StudyApis.vue'
import StudyAnswerMathTextField from '@/components/student/molecules/StudyAnswerMathTextField.vue'
import Tegaki, { Stroke } from '@/components/tegaki/Tegaki.vue'
import { QuestionAnswerType } from '@/mixins/requests/student/StudyApis.vue'

@Component({
  components: {
    StudyAnswerMathTextField,
    Tegaki,
  },
})
export default class StudyDummy5 extends Vue implements StudyDummyBaseMethod {
  @Prop()
  currentQuestionAnswer?: QuestionAnswerType

  @Ref()
  tegaki!: Tegaki

  private isHandInput = true
  private inputText = ''
  private strokeData: Stroke[][] = []

  public getQuestionAnswer(): QuestionAnswerType {
    // 入力値（手書き・数式キーボード選択、ストローク情報も）を取得
    return { inputs: [this.inputText], isHandInput: this.isHandInput, strokeData: this.strokeData }
  }

  public restoreInputedElements(): void {
    // 入力値を復元
    if (!this.currentQuestionAnswer) return
    if (this.currentQuestionAnswer.isHandInput != null) this.isHandInput = this.currentQuestionAnswer.isHandInput
    if (this.currentQuestionAnswer.inputs) this.inputText = this.currentQuestionAnswer.inputs[0]
    if (this.currentQuestionAnswer.strokeData) this.strokeData = this.currentQuestionAnswer.strokeData
  }

  public clearInputedElements(): void {
    // やり直し
    this.isHandInput = true
    this.inputText = ''
    this.strokeData = []
    this.tegaki.clear()
  }

  private beforeMount() {
    // 入力値を復元（ストローク情報を復元するにはbeforeMountじゃないとだめ）
    this.restoreInputedElements()
  }

  /**
   * 手書きのストローク情報を更新
   */
  private setStrokeData(strokes: Stroke[][]) {
    this.strokeData = strokes
  }
  /**
   * 入力形式を手書きとソフトウェアキーボードで切り替えた時に入力結果をリセット
   */
  private onChangeIsHandInput() {
    this.inputText = ''
  }
}
